// import React, { useState, useEffect } from 'react';
// import { Box, Flex, Text, Table, Tbody, Tr, Td, Input, Button, Stack } from '@chakra-ui/react'; import axios from 'axios';
// import { ACCOUNTS_URL } from '../../../../Globalapi/Globalapi';

// const FinancialStatement = () => {
//     const [data, setData] = useState({
//         expenses: [],
//         income: [],
//         indirect_expenses: [],
//         indirect_income: [],
//         total_expenses: 0,
//         total_income: 0,
//         total_indirect_expenses: 0,
//         total_indirect_income: 0,
//         GrossTotalE: 0,
//         GrossTotalI: 0,
//         CF_grossloss: 0,
//         netLoss: 0,
//         nettotalE: 0,
//         nettotalI: 0,
//     });
//     const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]); // Set default date as current date
//     const [loading, setLoading] = useState(false);
//     const cmp_id = sessionStorage.getItem('cmp_id');
//     const tdate = new Date().toISOString().split('T')[0];

//     const handleSearch = () => {
//         setLoading(true);
//         axios.post(`${ACCOUNTS_URL}/reports/load_p&l.php`, {
//             cmp_id,
//             tdate: selectedDate,  // Send the selected date to the backend
//         },

//     )
//             .then(response => {
//                 console.log(response);
//                 setData(prevState => ({
//                     ...prevState,
//                     ...response.data,
//                 }));
//                 setLoading(false);
//             })
//             .catch(error => {
//                 console.error('Error fetching financial data:', error);
//                 setLoading(false);
//             });
//     };

//     return (
//         <Box w='100%' margin="0 auto" background='white' minH='750px' maxH='750px' className='sb' overflowY='auto' borderRadius='20px' padding="4">
//             <Flex justify="end" mb="4" >
//                 <Stack direction="row" spacing={4} align="center">
//                     <Input
//                         type="date"
//                         value={selectedDate}
//                         onChange={(e) => setSelectedDate(e.target.value)}
//                         max={new Date().toISOString().split('T')[0]} // Ensure no future dates are selected
//                     />
//                     <Button onClick={handleSearch} isLoading={loading} bg='teal' color='white'>
//                         Search
//                     </Button>
//                 </Stack>
//             </Flex>
//             {/* Main Header */}
//             <Flex bg="blue.700" borderRadius='10px' color="white" padding="2" fontWeight="bold">
//                 <Box flex="1" textAlign="center">
//                     <Text>Expenses</Text>
//                 </Box>
//                 <Box flex="1" textAlign="center">
//                     <Text>Income</Text>
//                 </Box>
//             </Flex>

//             <Flex mt="4">
//                 {/* Direct Expenses Section */}
//                 <Box width="50%" mr='10px' borderRight="none">
//                     {Object.keys(data.expenses).map((expenseCategory, idx) => {
//                         console.log("Category:", expenseCategory);

//                         const categoryItems = Object.values(data.expenses[expenseCategory]).filter(
//                             (item) => item && typeof item === "object" && !("group_balance" in item)
//                         );

//                         console.log("Filtered Category Items:", categoryItems);

//                         return (
//                             <React.Fragment key={idx}>
//                                 <Flex bg="teal.50" padding="2" alignItems="center" justifyContent="space-between">
//                                     <Text fontWeight="bold">{expenseCategory}</Text>
//                                     <Text fontWeight="bold">
//                                         {data.expenses[expenseCategory].group_balance?.toFixed(2) || '0.00'}
//                                     </Text>
//                                 </Flex>

//                                 <Table variant="striped" size="sm" boxShadow="none">
//                                     <Tbody>
//                                         {categoryItems.map((item, index) => {

//                                             return (
//                                                 <Tr key={index}>
//                                                     <Td>{item.L_name || 'N/A'}</Td>
//                                                     <Td isNumeric>{item.debit?.toFixed(2) || '0.00'}</Td>
//                                                     <Td isNumeric>
//                                                         {item.credit > 0 ? item.credit.toFixed(2) : '\u00A0'}
//                                                     </Td>
//                                                     <Td></Td>
//                                                     <Td></Td>
//                                                 </Tr>
//                                             );
//                                         })}
//                                     </Tbody>
//                                 </Table>
//                             </React.Fragment>
//                         );
//                     })}
//                 </Box>

//                 {/* Direct Incomes Section */}
//                 <Box width="50%" borderRight="none">
//                     {Object.keys(data.income).map((incomeCategory, idx) => {
//                         console.log("Income Category:", incomeCategory);

//                         const categoryItems = Object.values(data.income[incomeCategory]).filter(
//                             (item) => item && typeof item === "object" && !("group_balance" in item)
//                         );

//                         console.log("Filtered Income Items:", categoryItems);

//                         return (
//                             <React.Fragment key={idx}>
//                                 <Flex bg="teal.50" padding="2" alignItems="center" justifyContent="space-between">
//                                     <Text fontWeight="bold">{incomeCategory}</Text>
//                                     <Text fontWeight="bold">
//                                         {data.income[incomeCategory].group_balance?.toFixed(2) || '0.00'}
//                                     </Text>
//                                 </Flex>

//                                 <Table variant="striped" size="sm" boxShadow="none">
//                                     <Tbody>
//                                         {categoryItems.map((income, index) => {
//                                             const debit = Number(income.debit) > 0 ? Number(income.debit).toFixed(2) : '\u00A0';
//                                             const credit = Number(income.credit) > 0 ? Number(income.credit).toFixed(2) : '\u00A0';

//                                             return (
//                                                 <Tr key={index}>
//                                                     <Td>{income.L_name || 'N/A'}</Td>
//                                                     <Td isNumeric>{debit}</Td>
//                                                     <Td isNumeric>{credit}</Td>
//                                                     <Td></Td>
//                                                     <Td></Td>
//                                                 </Tr>
//                                             );
//                                         })}
//                                     </Tbody>
//                                 </Table>

//                             </React.Fragment>
//                         );
//                     })}
//                 </Box>

//             </Flex>

//             <Box mt="4" >
//                 <Table size="sm" boxShadow="none">
//                     <Tbody>

//                         <Tr fontWeight="bold">
//                             {data.grossProfit !== 0 && (
//                                 <>
//                                     <Td color="green.500">Gross Profit</Td>
//                                     <Td isNumeric color="green.500">{(data.grossProfit ?? 0).toFixed(2)}</Td>

//                                 </>
//                             )}
//                             {data.grossProfit === 0 && (
//                                 <>
//                                     <Td colSpan={1}></Td>
//                                     <Td colSpan={1}></Td>

//                                 </>
//                             )}
//                             {data.grossLoss !== 0 && (
//                                 <>
//                                     <Td color="red.500">Gross Loss</Td>
//                                     <Td isNumeric color="red.500">{(data.grossLoss ?? 0).toFixed(2)}</Td>
//                                 </>
//                             )}
//                             {data.grossLoss === 0 && (
//                                 <>
//                                     <Td colSpan={1}></Td>
//                                     <Td colSpan={1}></Td>
//                                 </>
//                             )}
//                         </Tr>

//                         <Tr bg="blue.100" fontWeight="bold">
//                             <Td>Gross Total</Td>
//                             <Td isNumeric>{(data.GrossTotalE ?? 0).toFixed(2)}</Td>
//                             <Td>Gross Total</Td>
//                             <Td isNumeric>{(data.GrossTotalI ?? 0).toFixed(2)}</Td>
//                         </Tr>

//                     </Tbody>
//                 </Table>
//             </Box>
//             <Box mt="4" >
//                 <Table size="sm" boxShadow="none">
//                     <Tbody>

//                         <Tr>
//                             {data.CF_grossloss !== 0 && (
//                                 <>
//                                     <Td color="red.500" fontWeight="bold">C/F Gross Loss</Td>
//                                     <Td isNumeric color="red.500">{(data.CF_grossloss ?? 0).toFixed(2)}</Td>
//                                 </>
//                             )}
//                             {data.CF_grossloss === 0 && (
//                                 <>
//                                     <Td colSpan={1}></Td>
//                                     <Td colSpan={1}></Td>
//                                     <Td colSpan={1}></Td>
//                                     <Td colSpan={1}></Td>
//                                     <Td colSpan={1}></Td>
//                                     <Td colSpan={1}></Td>
//                                     <Td colSpan={1}></Td>
//                                     <Td colSpan={1}></Td>

//                                 </>
//                             )}
//                             {data.CF_grossProfit !== 0 && (
//                                 <>
//                                     <Td color="green.500" fontWeight="bold">C/F Gross Profit</Td>
//                                     <Td isNumeric color="green.500">{(data.CF_grossProfit ?? 0).toFixed(2)}</Td>
//                                 </>
//                             )}
//                             {data.CF_grossProfit === 0 && (
//                                 <>
//                                     <Td colSpan={1}></Td>
//                                     <Td colSpan={1}></Td>
//                                     <Td colSpan={1}></Td>
//                                     <Td colSpan={1}></Td>
//                                     <Td colSpan={1}></Td>
//                                     <Td colSpan={1}></Td>
//                                     <Td colSpan={1}></Td>

//                                 </>
//                             )}
//                         </Tr>

//                     </Tbody>
//                 </Table>
//             </Box>

//             <Flex mt="4">
//                 {/* Indirect Expenses Section */}
//                 <Box width="50%" borderRight="none">
//                     {Object.keys(data.indirect_expenses).map((expenseCategory, idx) => {
//                         console.log("Indirect Expense Category:", expenseCategory);

//                         const categoryItems = Object.values(data.indirect_expenses[expenseCategory]).filter(
//                             (item) => item && typeof item === "object" && !("group_balance" in item)
//                         );

//                         console.log("Filtered Indirect Expense Items:", categoryItems);

//                         return (
//                             <React.Fragment key={idx}>
//                                 <Flex bg="teal.50" padding="2" alignItems="center" justifyContent="space-between">
//                                     <Text fontWeight="bold">{expenseCategory}</Text>
//                                     <Text fontWeight="bold">
//                                         {data.indirect_expenses[expenseCategory].group_balance?.toFixed(2) || '0.00'}
//                                     </Text>
//                                 </Flex>

//                                 <Table variant="striped" colorScheme="teal" size="sm" boxShadow="none">
//                                     <Tbody>
//                                         {categoryItems.map((expense, index) => {
//                                             console.log("L_name:", expense.L_name);
//                                             console.log("Debit:", expense.debit);
//                                             console.log("Credit:", expense.credit); // If applicable, include if there's a credit value.

//                                             return (
//                                                 <Tr key={index}>
//                                                     <Td>{expense.L_name || 'N/A'}</Td>
//                                                     <Td isNumeric>{expense.debit?.toFixed(2) || '0.00'}</Td>
//                                                     <Td isNumeric>{expense.credit?.toFixed(2) || '0.00'}</Td>
//                                                 </Tr>
//                                             );
//                                         })}
//                                     </Tbody>
//                                 </Table>
//                             </React.Fragment>
//                         );
//                     })}

//                 </Box>

//                 {/* Indirect Incomes Section */}
//                 <Box width="50%" >
//                     {Object.keys(data.indirect_income).map((incomeCategory, idx) => {
//                         console.log("Indirect Income Category:", incomeCategory);

//                         const categoryItems = Object.values(data.indirect_income[incomeCategory]).filter(
//                             (item) => item && typeof item === "object" && !("group_balance" in item)
//                         );

//                         console.log("Filtered Indirect Income Items:", categoryItems);

//                         return (
//                             <React.Fragment key={idx}>
//                                 <Flex bg="teal.50" padding="2" alignItems="center" justifyContent="space-between">
//                                     <Text fontWeight="bold">{incomeCategory}</Text>
//                                     <Text fontWeight="bold">
//                                         {data.indirect_income[incomeCategory].group_balance?.toFixed(2) || '0.00'}
//                                     </Text>
//                                 </Flex>

//                                 <Table variant="striped" colorScheme="teal" size="sm" boxShadow="none">
//                                     <Tbody>
//                                         {categoryItems.map((income, index) => {
//                                             const credit = Number(income.credit) > 0 ? Number(income.credit).toFixed(2) : '\u00A0';
//                                             const debit = Number(income.debit) > 0 ? Number(income.debit).toFixed(2) : '\u00A0';
//                                             return (
//                                                 <Tr key={index}>
//                                                     <Td>{income.L_name || 'N/A'}</Td>
//                                                     <Td isNumeric>{debit}</Td>
//                                                     <Td isNumeric>{credit}</Td>
//                                                 </Tr>
//                                             );
//                                         })}
//                                     </Tbody>
//                                 </Table>

//                             </React.Fragment>
//                         );
//                     })}
//                 </Box>
//             </Flex>

//             <Box mt="4" >
//                 <Table size="sm" boxShadow="none">
//                     <Tbody>

//                         <Tr>
//                             {data.netProfit !== 0 && (
//                                 <>
//                                     <Td color="green.500" fontWeight="bold">Net Profit</Td>
//                                     <Td isNumeric color="green.500">{(data.netProfit ?? 0).toFixed(2)}</Td>
//                                 </>
//                             )}
//                             {data.netProfit === 0 && (
//                                 <>
//                                     <Td colSpan={1}></Td>
//                                     <Td colSpan={1}></Td>
//                                 </>
//                             )}
//                             {data.netLoss !== 0 && (
//                                 <>
//                                     <Td color="red.500" fontWeight="bold">Net Loss</Td>
//                                     <Td isNumeric color="red.500">{(data.netLoss ?? 0).toFixed(2)}</Td>
//                                 </>
//                             )}
//                             {data.netLoss === 0 && (
//                                 <>
//                                     <Td colSpan={1}></Td>
//                                     <Td colSpan={1}></Td>
//                                 </>
//                             )}
//                         </Tr>

//                         <Tr bg="blue.100" fontWeight="bold">
//                             <Td>Net Total</Td>
//                             <Td isNumeric>{(data.nettotalE ?? 0).toFixed(2)}</Td>
//                             <Td>Net Total</Td>
//                             <Td isNumeric>{(data.nettotalI ?? 0).toFixed(2)}</Td>
//                         </Tr>
//                     </Tbody>
//                 </Table>
//             </Box>
//         </Box>
//     );
// };

// export default FinancialStatement;

import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Text,
  Table,
  Tbody,
  Tr,
  Td,
  Input,
  Button,
  Stack,
  Spinner,
} from "@chakra-ui/react";
import axios from "axios";
import { ACCOUNTS_URL } from "../../../../Globalapi/Globalapi";

// A reusable component for rendering the individual P&L sections
const StatementSection = ({ title, data, isIncome = false }) => (
  <React.Fragment>
    {/* Category Header */}
    <Flex
      bg="teal.50"
      padding="2"
      alignItems="center"
      justifyContent="space-between"
      borderTopRadius="md"
    >
      <Text fontWeight="bold">{title}</Text>
      <Text fontWeight="bold">
        {/* Use the group_balance property from the first item in the data array */}
        {data.group_balance?.toFixed(2) || "0.00"}
      </Text>
    </Flex>

    {/* Detail Table */}
    <Box
      overflowX="auto"
      borderBottomRadius="md"
      mb={4}
      boxShadow="sm"
      bg="white"
    >
      <Table variant="striped" colorScheme="gray" size="sm" minWidth="400px">
        <Tbody>
          {/* Filter out the 'group_balance' property itself for iteration */}
          {Object.values(data)
            .filter(
              (item) =>
                item && typeof item === "object" && !("group_balance" in item)
            )
            .map((item, index) => {
              const amount = isIncome
                ? Number(item.credit) > 0
                  ? Number(item.credit).toFixed(2)
                  : "\u00A0"
                : Number(item.debit) > 0
                ? Number(item.debit).toFixed(2)
                : "\u00A0";
              const contraAmount = isIncome
                ? Number(item.debit) > 0
                  ? Number(item.debit).toFixed(2)
                  : "\u00A0"
                : Number(item.credit) > 0
                ? Number(item.credit).toFixed(2)
                : "\u00A0";

              return (
                <Tr key={index}>
                  {/* Show account name */}
                  <Td pr={0} width="60%">
                    {item.L_name || "N/A"}
                  </Td>
                  {/* Show main amount (Debit for Expense, Credit for Income) */}
                  <Td isNumeric fontWeight="semibold" width="20%">
                    {amount}
                  </Td>
                  {/* Show contra amount (Credit for Expense, Debit for Income) */}
                  <Td isNumeric fontSize="xs" color="gray.500" width="20%">
                    {contraAmount}
                  </Td>
                </Tr>
              );
            })}
        </Tbody>
      </Table>
    </Box>
  </React.Fragment>
);

const FinancialStatement = () => {
  const [data, setData] = useState({
    // Initialize state variables here... (rest of the initial state remains the same)
    expenses: {},
    income: {},
    indirect_expenses: {},
    indirect_income: {},
    total_expenses: 0,
    total_income: 0,
    total_indirect_expenses: 0,
    total_indirect_income: 0,
    GrossTotalE: 0,
    GrossTotalI: 0,
    CF_grossloss: 0,
    CF_grossProfit: 0, // Added based on your usage in the return block
    grossProfit: 0, // Added based on your usage in the return block
    grossLoss: 0, // Added based on your usage in the return block
    netLoss: 0,
    nettotalE: 0,
    nettotalI: 0,
  });
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [loading, setLoading] = useState(false);
  const cmp_id = sessionStorage.getItem("cmp_id");

  const handleSearch = () => {
    setLoading(true);
    axios
      .post(`${ACCOUNTS_URL}/reports/load_p&l.php`, {
        cmp_id,
        tdate: selectedDate,
      })
      .then((response) => {
        console.log(response.data);
        // Ensure response data keys are mapped correctly to state keys,
        // and handle cases where they might be missing or null/empty objects.
        setData((prevState) => ({
          ...prevState,
          ...response.data,
          // Ensure nested objects default to empty if not present
          expenses: response.data.expenses || {},
          income: response.data.income || {},
          indirect_expenses: response.data.indirect_expenses || {},
          indirect_income: response.data.indirect_income || {},
        }));
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching financial data:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    handleSearch(); // Fetch data on initial load
  }, []);

  // Helper component for the summary rows to handle the 4-column layout for Gross/Net totals
  const SummaryRow = ({
    totalELabel,
    totalEValue,
    totalILabel,
    totalIValue,
    bgColor = "blue.100",
  }) => (
    <Tr bg={bgColor} fontWeight="bold">
      <Td w={{ base: "50%", sm: "25%" }} borderRight="1px solid lightgray">
        {totalELabel}
      </Td>
      <Td w={{ base: "50%", sm: "25%" }} isNumeric>
        {totalEValue}
      </Td>
      <Td
        w={{ base: "50%", sm: "25%" }}
        borderRight="1px solid lightgray"
        display={{ base: "none", sm: "table-cell" }}
      >
        {totalILabel}
      </Td>
      <Td
        w={{ base: "50%", sm: "25%" }}
        isNumeric
        display={{ base: "none", sm: "table-cell" }}
      >
        {totalIValue}
      </Td>
    </Tr>
  );

  // Helper component for Profit/Loss display
  const ProfitLossRow = ({ label, value, isLoss = false, offset = false }) => (
    <>
      <Td
        colSpan={offset ? 1 : 2}
        color={isLoss ? "red.500" : "green.500"}
        fontWeight="bold"
        // Only show label on one side for stacking effect on small screens
        w={{ base: "50%", sm: "auto" }}
      >
        {label}
      </Td>
      <Td
        colSpan={offset ? 1 : 2}
        isNumeric
        color={isLoss ? "red.500" : "green.500"}
        fontWeight="bold"
        w={{ base: "50%", sm: "auto" }}
      >
        {value}
      </Td>
    </>
  );

  // --- RENDER FUNCTION ---
  return (
    <Box
      w={{ base: "100%", md: "90%", lg: "100%" }}
      margin="0 auto"
      background="white"
      minH="600px"
      borderRadius="lg"
      p={{ base: 4, md:4 }}
      shadow="lg"
      overflowX="hidden" // Prevent horizontal overflow of the main container
    >
      {/* Header: Date Picker and Search Button */}
      <Flex justify={{ base: "center", sm: "flex-end" }} mb="4" w="100%">
        <Stack
          direction={{ base: "column", sm: "row" }}
          spacing={3}
          align="center"
          w={{ base: "100%", sm: "auto" }}
        >
          <Input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            max={new Date().toISOString().split("T")[0]}
            w={{ base: "100%", sm: "auto" }} // Full width on mobile
          />
          <Button
            onClick={handleSearch}
            isLoading={loading}
            bg="teal.500"
            color="white"
            w={{ base: "100%", sm: "auto" }} // Full width on mobile
            _hover={{ bg: "teal.600" }}
          >
            Search
          </Button>
        </Stack>
      </Flex>

      {/* Main Header (Expenses vs Income) */}
      <Flex
        bg="blue.700"
        borderRadius="md"
        color="white"
        padding="3"
        fontWeight="bold"
        fontSize={{ base: "sm", md: "md" }}
      >
        <Box flex="1" textAlign="center">
          <Text>Expenses</Text>
        </Box>
        <Box flex="1" textAlign="center">
          <Text>Income</Text>
        </Box>
      </Flex>

      {/* DIRECT TRADING SECTION (EXPENSES/INCOME) */}
      <Flex
        mt="4"
        direction={{ base: "column", md: "row" }} // Stacks vertically on mobile/tablet, side-by-side on desktop
        gap={5} // Space between stacked columns
      >
        {/* Direct Expenses Section */}
        <Box flex="1" width={{ base: "100%", md: "50%" }}>
          {Object.keys(data.expenses).map((categoryName) => (
            <StatementSection
              key={categoryName}
              title={categoryName}
              data={data.expenses[categoryName]}
              isIncome={false}
            />
          ))}
        </Box>

        {/* Direct Incomes Section */}
        <Box flex="1" width={{ base: "100%", md: "50%" }}>
          {Object.keys(data.income).map((categoryName) => (
            <StatementSection
              key={categoryName}
              title={categoryName}
              data={data.income[categoryName]}
              isIncome={true}
            />
          ))}
        </Box>
      </Flex>

      {/* --- GROSS PROFIT/LOSS & TOTALS SECTION --- */}
      <Box mt="4" overflowX="auto">
        <Table size="sm" variant="simple" minWidth="600px">
          <Tbody>
            {/* Gross Profit / Gross Loss Row */}
            <Tr fontWeight="bold" borderTop="2px solid" borderColor="gray.300">
              {data.grossProfit !== 0 || data.grossLoss !== 0 ? (
                <>
                  {data.grossLoss !== 0 && (
                    <ProfitLossRow
                      label="Gross Loss"
                      value={(data.grossLoss ?? 0).toFixed(2)}
                      isLoss={true}
                      offset={true}
                    />
                  )}
                  {data.grossProfit !== 0 && (
                    <ProfitLossRow
                      label="Gross Profit"
                      value={(data.grossProfit ?? 0).toFixed(2)}
                      isLoss={false}
                      offset={true}
                    />
                  )}
                </>
              ) : (
                <Tr>
                  <Td colSpan={4}>No Gross P/L Calculated</Td>
                </Tr>
              )}
            </Tr>

            {/* Gross Totals Row */}
            <SummaryRow
              totalELabel="Gross Total"
              totalEValue={(data.GrossTotalE ?? 0).toFixed(2)}
              totalILabel="Gross Total"
              totalIValue={(data.GrossTotalI ?? 0).toFixed(2)}
            />
          </Tbody>
        </Table>
      </Box>

      {/* --- INDIRECT OPERATING SECTION (EXPENSES/INCOME) --- */}
      <Text
        mt={8}
        mb={2}
        fontSize="lg"
        fontWeight="semibold"
        textAlign="center"
      >
        Operating Activities
      </Text>

      <Flex direction={{ base: "column", md: "row" }} gap={5}>
        {/* Indirect Expenses Section */}
        <Box flex="1" width={{ base: "100%", md: "50%" }}>
          {Object.keys(data.indirect_expenses).map((categoryName) => (
            <StatementSection
              key={categoryName}
              title={categoryName}
              data={data.indirect_expenses[categoryName]}
              isIncome={false}
            />
          ))}
        </Box>

        {/* Indirect Incomes Section */}
        <Box flex="1" width={{ base: "100%", md: "50%" }}>
          {Object.keys(data.indirect_income).map((categoryName) => (
            <StatementSection
              key={categoryName}
              title={categoryName}
              data={data.indirect_income[categoryName]}
              isIncome={true}
            />
          ))}
        </Box>
      </Flex>

      {/* --- NET PROFIT/LOSS & TOTALS SECTION --- */}
      <Box mt="4" overflowX="auto">
        <Table size="sm" variant="simple" minWidth="600px">
          <Tbody>
            {/* Net Profit / Net Loss Row */}
            <Tr fontWeight="bold" borderTop="2px solid" borderColor="gray.300">
              {data.netProfit !== 0 || data.netLoss !== 0 ? (
                <>
                  {data.netLoss !== 0 && (
                    <ProfitLossRow
                      label="Net Loss"
                      value={(data.netLoss ?? 0).toFixed(2)}
                      isLoss={true}
                      offset={true}
                    />
                  )}
                  {data.netProfit !== 0 && (
                    <ProfitLossRow
                      label="Net Profit"
                      value={(data.netProfit ?? 0).toFixed(2)}
                      isLoss={false}
                      offset={true}
                    />
                  )}
                </>
              ) : (
                <Tr>
                  <Td colSpan={4}>No Net P/L Calculated</Td>
                </Tr>
              )}
            </Tr>

            {/* Net Totals Row */}
            <SummaryRow
              totalELabel="Net Total"
              totalEValue={(data.nettotalE ?? 0).toFixed(2)}
              totalILabel="Net Total"
              totalIValue={(data.nettotalI ?? 0).toFixed(2)}
            />
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};

export default FinancialStatement;
